import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-slash-lined",
  "use": "rt-base-slash-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-slash-lined\"><defs><style type=\"text/css\"></style></defs><path d=\"M306.1 912h-65.2c-5.9 0-9.8-6.3-7.2-11.6l469.8-779.6c2.7-5.4 8.3-8.8 14.3-8.8H783c5.9 0 9.8 6.3 7.2 11.6L320.4 903.2c-2.7 5.4-8.2 8.8-14.3 8.8z\" p-id=\"3297\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/slash-lined.svg
// module id = 1749
// module chunks = 228